var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoChecklists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.482,
    height: 168.692,
    viewBox: "0 0 181.482 168.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4908",
    "data-name": "Group 4908",
    transform: "translate(-679.518 -1444.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-63",
    transform: "translate(679.518 1444.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8178",
    "data-name": "Path 8178",
    d: "M186.909,157.379c13.222-31.307,14.9-75.552-7.891-103.032-12.57-15.16-32.347-20.2-51.226-21.324-16.922-1.025-35.03-.606-50.4,7.419C51.334,53.993,50.689,86.264,31.173,105.3c-15.736,15.352-22.261,37.229-8.827,66.014s38.38,35.31,62.944,26.1,35.694-11.13,65.247-6.525c13.583,2.119,23.439-8.06,29.4-19.056C182.487,167.127,184.832,162.3,186.909,157.379Z",
    transform: "translate(-15.086 -32.619)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8179",
    "data-name": "Path 8179",
    d: "M186.909,157.379c13.222-31.307,14.9-75.552-7.891-103.032-12.57-15.16-32.347-20.2-51.226-21.324-16.922-1.025-35.03-.606-50.4,7.419C51.334,53.993,50.689,86.264,31.173,105.3c-15.736,15.352-22.261,37.229-8.827,66.014s38.38,35.31,62.944,26.1,35.694-11.13,65.247-6.525c13.583,2.119,23.439-8.06,29.4-19.056C182.487,167.127,184.832,162.3,186.909,157.379Z",
    transform: "translate(-15.086 -32.619)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Note--inject-40",
    transform: "translate(728.139 1454.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2628",
    "data-name": "Rectangle 2628",
    width: 90.735,
    height: 120.606,
    transform: "translate(0.213 11.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24598",
    "data-name": "Path 24598",
    d: "M255.471,210.189H164.736a.236.236,0,0,1-.236-.236V89.346a.236.236,0,0,1,.236-.236h90.735a.236.236,0,0,1,.236.236V209.952A.236.236,0,0,1,255.471,210.189Zm-90.5-.473h90.262V89.583H164.973Z",
    transform: "translate(-164.5 -77.867)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2629",
    "data-name": "Rectangle 2629",
    width: 69.062,
    height: 2.835,
    transform: "translate(10.151 73.623)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2630",
    "data-name": "Rectangle 2630",
    width: 56.26,
    height: 2.835,
    transform: "translate(22.953 37.91)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2631",
    "data-name": "Rectangle 2631",
    width: 69.062,
    height: 2.835,
    transform: "translate(10.151 55.769)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24599",
    "data-name": "Path 24599",
    d: "M237.308,296.67q-1.318,1.418-2.694,2.835H186V296.67Z",
    transform: "translate(-175.84 -187.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24600",
    "data-name": "Path 24600",
    d: "M250.875,258.89c-.6.945-1.224,1.89-1.867,2.835H186V258.89Z",
    transform: "translate(-175.84 -167.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24601",
    "data-name": "Path 24601",
    d: "M199.575,337.93s-4.036,1.961-15.34,3.02H165.45",
    transform: "translate(-165.001 -209.101)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24602",
    "data-name": "Path 24602",
    d: "M352.79,183.114h0a7.486,7.486,0,0,0,1.229-3.511c.142-1.578.246-3.417.279-4.537l.18-6.186v13.289Z",
    transform: "translate(-263.809 -119.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24603",
    "data-name": "Path 24603",
    d: "M287.255,195.787c0,.577-5.283,14.508-15.122,29.772-.6.945-1.224,1.89-1.867,2.835a129.233,129.233,0,0,1-11.7,15.018q-1.318,1.418-2.694,2.835c-6.923,7.022-14.9,13-23.837,16.427.51-.26,8.294-4.187,9.99-16.427q.189-1.347.269-2.835a50.051,50.051,0,0,0-1.72-15.018q-.35-1.38-.78-2.835c-2.183-7.377-5.936-16.12-11.914-26.464l-1.541-3.355,10.066,2.835c44.956,10.439,50.826-2.835,50.826-2.835A.218.218,0,0,1,287.255,195.787Z",
    transform: "translate(-197.116 -134.107)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24604",
    "data-name": "Path 24604",
    d: "M273.327,284.83a20.879,20.879,0,0,1-.057,2.509",
    transform: "translate(-221.868 -181.095)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24605",
    "data-name": "Path 24605",
    d: "M250.51,216.74c6.531,8.459,9.825,22.755,10.685,29.536",
    transform: "translate(-209.864 -145.183)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24606",
    "data-name": "Path 24606",
    d: "M182.647,106.821a4.754,4.754,0,1,1,0-9.5.709.709,0,0,1,0,1.418,3.336,3.336,0,1,0,3.308,3.336.709.709,0,0,1,1.418,0,4.754,4.754,0,0,1-4.726,4.749Z",
    transform: "translate(-171.485 -82.195)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24607",
    "data-name": "Path 24607",
    d: "M182.764,87.985c-4.343,0-4.579-9.385-4.584-11.266v-.057c0-1.89.222-11.342,4.584-11.342s4.664,10.179,4.688,11.342l-3.781.071a23.1,23.1,0,0,0-.945-6.46,22.882,22.882,0,0,0-.775,6.37V76.7a22.423,22.423,0,0,0,.8,6.4c.043-.137.085-.288.132-.473l.3-1.025,2.637.77a1.035,1.035,0,0,1,.7,1.285h0C185.76,86.524,184.489,87.985,182.764,87.985Z",
    transform: "translate(-171.715 -65.32)",
    fill: "#bfbfbf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24608",
    "data-name": "Path 24608",
    d: "M191.4,102.783a.709.709,0,0,1-.709-.709,3.336,3.336,0,0,0-3.308-3.336.709.709,0,0,1,0-1.418,4.759,4.759,0,0,1,4.726,4.754.709.709,0,0,1-.709.709Z",
    transform: "translate(-176.193 -82.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24609",
    "data-name": "Path 24609",
    d: "M230.381,106.824a4.754,4.754,0,0,1,0-9.5.709.709,0,1,1,0,1.418,3.336,3.336,0,1,0,3.336,3.336.709.709,0,1,1,1.418,0A4.759,4.759,0,0,1,230.381,106.824Z",
    transform: "translate(-196.819 -82.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24610",
    "data-name": "Path 24610",
    d: "M230.174,87.985c-4.343,0-4.584-9.385-4.584-11.266v-.057c0-1.89.217-11.342,4.584-11.342s4.664,10.179,4.688,11.342l-3.781.071a23.066,23.066,0,0,0-.945-6.46,22.92,22.92,0,0,0-.77,6.37V76.7a22.632,22.632,0,0,0,.8,6.427c.047-.137.09-.288.137-.473l.3-1.025,2.637.77a1.035,1.035,0,0,1,.7,1.285h0C233.17,86.524,231.9,87.985,230.174,87.985Z",
    transform: "translate(-196.72 -65.32)",
    fill: "#bfbfbf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24611",
    "data-name": "Path 24611",
    d: "M238.774,102.783a.709.709,0,0,1-.709-.709,3.341,3.341,0,0,0-3.336-3.336.709.709,0,0,1,0-1.418,4.759,4.759,0,0,1,4.754,4.754A.709.709,0,0,1,238.774,102.783Z",
    transform: "translate(-201.167 -82.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24612",
    "data-name": "Path 24612",
    d: "M277.791,106.824a4.754,4.754,0,0,1,0-9.5.709.709,0,0,1,0,1.418,3.336,3.336,0,1,0,3.336,3.336.709.709,0,1,1,1.418,0A4.759,4.759,0,0,1,277.791,106.824Z",
    transform: "translate(-221.824 -82.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24613",
    "data-name": "Path 24613",
    d: "M277.574,87.985c-4.343,0-4.579-9.385-4.584-11.266v-.057c0-1.89.222-11.342,4.584-11.342s4.669,10.179,4.688,11.342l-3.781.071a23.1,23.1,0,0,0-.945-6.46,22.883,22.883,0,0,0-.761,6.389v.057a22.425,22.425,0,0,0,.8,6.4c.043-.137.09-.288.132-.473l.3-1.025,2.632.77a1.035,1.035,0,0,1,.7,1.285h0C280.556,86.524,279.3,87.985,277.574,87.985Z",
    transform: "translate(-221.72 -65.32)",
    fill: "#bfbfbf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24614",
    "data-name": "Path 24614",
    d: "M286.184,102.783a.709.709,0,0,1-.709-.709,3.341,3.341,0,0,0-3.336-3.336.709.709,0,0,1,0-1.418,4.759,4.759,0,0,1,4.759,4.754A.714.714,0,0,1,286.184,102.783Z",
    transform: "translate(-226.172 -82.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24615",
    "data-name": "Path 24615",
    d: "M324.867,106.821a4.754,4.754,0,1,1,0-9.5.709.709,0,0,1,0,1.418,3.336,3.336,0,1,0,3.332,3.336.709.709,0,1,1,1.418,0A4.754,4.754,0,0,1,324.867,106.821Z",
    transform: "translate(-246.495 -82.195)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24616",
    "data-name": "Path 24616",
    d: "M324.984,87.985c-4.343,0-4.579-9.385-4.584-11.266v-.057c0-1.89.222-11.342,4.584-11.342s4.678,10.2,4.678,11.361l-3.781.071a23.28,23.28,0,0,0-.945-6.46,22.683,22.683,0,0,0-.775,6.37v.057a22.633,22.633,0,0,0,.818,6.408c.047-.137.09-.288.137-.473l.3-1.025,2.637.77a1.035,1.035,0,0,1,.7,1.285h0C327.98,86.524,326.709,87.985,324.984,87.985Z",
    transform: "translate(-246.725 -65.32)",
    fill: "#bfbfbf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24617",
    "data-name": "Path 24617",
    d: "M333.589,102.783a.709.709,0,0,1-.709-.709,3.336,3.336,0,0,0-3.332-3.336.709.709,0,0,1,0-1.418,4.759,4.759,0,0,1,4.749,4.754A.709.709,0,0,1,333.589,102.783Z",
    transform: "translate(-251.177 -82.198)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-40",
    transform: "translate(792.627 1560.048)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_601",
    "data-name": "Ellipse 601",
    cx: 17.736,
    cy: 17.736,
    rx: 17.736,
    ry: 17.736,
    transform: "matrix(0.224, -0.975, 0.975, 0.224, 0, 34.569)",
    fill: "#64b5f6",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24618",
    "data-name": "Path 24618",
    d: "M344.759,321.985a1.649,1.649,0,0,1-1.654,1.654h-7.037v7.041a1.654,1.654,0,0,1-3.308,0v-7.056h-7.037a1.654,1.654,0,1,1,0-3.308h7.037v-7.022a1.654,1.654,0,1,1,3.308,0v7.022h7.037a1.654,1.654,0,0,1,1.654,1.668Z",
    transform: "translate(-313.15 -300.717)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChecklists);
export default __webpack_public_path__ + "static/media/noChecklists.b51e0d42667b7ed2aac6293d00d853f8.svg";
export { ForwardRef as ReactComponent };